<div class="location-needed-container" data-test="location-needed-container">
  <div class="location-needed-prompt">
    <img class="no-therapy-icon" src="/assets/no-therapy-in-state.svg" alt="Icon showing clouds around location, location must be provided"/>
  
    <div class="title">
      When finding a provider, your location matters <br *ngIf="!isMobile">(even for video sessions).
    </div>
    
    <div class="details">
      Please select your location below to see licensed therapists in your state.
    </div>
  </div>

  <div *ngIf="!isMobile; else stateSelectMobile" class="state-select-container">
    <section>
      <div>
        <form [formGroup]="stateForm">
          <filter-select
            formControlName="state"
            [categorizedOptions]="stateOptions"
            placeholder="My location"
            data-test="state-select"
          ></filter-select>
        </form>
      </div>
    </section>
  </div>

  <ng-template #stateSelectMobile>
    <section class="mobile-state-listbox" role="listbox" #listbox>
      <h4 class="location-label">My location</h4>
      <div
        *ngFor="let option of stateOptions[0].options; let i = index"
        class="state-select-list-item"
        (mousedown)="$event.preventDefault()"
        [attr.aria-selected]="false"
        [attr.aria-label]="option.name || 'Empty'"
        (click)="updateStateMobile(option.value)"
        (keydown)="onMobileStateSelectKeyDown($event, option.value)"
        (keyup)="onMobileStateSelectKeyUp($event)"
        role="option"
        tabindex="0"
      >
        <span class="state-select-list-item-label">{{ option.name }}</span>
      </div>
    </section>
  </ng-template>
</div>